import styled, { css } from 'styled-components'
import colors from 'utils/styling/colors'
import Flex from 'components/priority/Flex/Flex'

// Styled Container with hover styles
export const Container = styled(Flex)(
  () => css`
    cursor: pointer;
    align-items: center;
    height: 16px;
    transition:
      color 0.3s ease,
      fill 0.3s ease;

    &:hover {
      color: ${colors('blue')};
    }

    & svg {
      fill: ${colors('gray2')};
      transition: fill 0.3s ease;
    }

    &:hover svg {
      fill: ${colors('blue')};
    }
  `,
)

export default Container
